<template>
    <div>
        <limitless-page-header title="NTAPS Printserver" sub-title="Bachutskrift Excel"></limitless-page-header>

        <div class="content">
            <div v-if="loading">
                <i class="icon-spinner2 spinner"></i>
            </div>
            <div v-else-if="errors">
                <div
                    v-for="(fieldError, field) in errors"
                    :key="'errors-' + field"
                    class="alert alert-danger"
                >
                    {{ field }}: {{ fieldError[0] }}
                </div>
            </div>
            <div v-else-if="response">
                <div v-if="response.printed" class="alert alert-success"><b>✓ Utskrift påbörjad</b></div>
                <div v-else class="alert alert-danger"><b>X Ej utskriven:</b> {{ response.message }}</div>
                <div
                    v-for="(order, o_index) in response.shipments"
                    :key="'result-' + o_index"
                    class="alert"
                    :class="{ 'alert-success': order.printed, 'alert-danger': !order.printed }"
                >
                    <div>{{ order.card_uid }}: {{ order.message }}</div>
                    <div v-if="order.extra_message">{{ order.extra_message }}</div>
                </div>
            </div>
            <div v-else-if="!sent_to_printer">
                <div class="card" style="max-width: 800px;">
                    <div class="card-header bg-light header-elements-inline">
                        <h5 class="card-title">Ladda upp och skriv ut från batch-fil</h5>
                        <div class="header-elements">
                            <a class="btn btn-light btn-labeled btn-labeled-left" href="/storage/mall_excel_batchutskrift.xlsx" download>
                                <b><i class="icon-file-xlsx"></i></b>Ladda ner Excel-mall
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <ValidationObserver ref="printform">
                            <form @submit.prevent="printBatch">
                                <ValidationProvider vid="file" name="Fil" v-slot="{ errors }">
                                    <div class="form-group">
                                        <limitless-file-input @change="inputFileChanged" ref="fileInput"></limitless-file-input>
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <div class="row">
                                    <div class="col-auto d-flex flex-grow-1">
                                        <div class="col-form-label pr-1">Välj skrivare:</div>
                                        <div class="flex-grow-1">
                                            <select-with-validation
                                                vid="printer_tag"
                                                label="Skrivare"
                                                v-model="printer_tag"
                                                :reduce="opt => opt.tag"
                                                placeholder="-- Välj skrivare --"
                                                :disabled="loading"
                                                component="label-printer-filter"
                                                hide-label
                                                rules="required"
                                            >
                                            </select-with-validation>
                                        </div>
                                    </div>
                                    <div class="col-auto flex-shrink-1">
                                        <limitless-button :busy="loading" icon="icon-printer2" @click="printBatch" class="d-block">SKRIV UT</limitless-button>
                                    </div>
                                </div>
                                <div class="custom-control custom-checkbox mt-3">
                                    <input type="checkbox" class="custom-control-input" id="chk-default-printer" v-model="set_as_defualt_printer">
                                    <label class="custom-control-label" for="chk-default-printer">Sätt vald skrivare som standardskrivare på denna dator</label>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
            <div v-else class="alert alert-danger"><b>X Ej utskriven:</b> Något gick fel....</div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import Cookies from 'js-cookie';
import SelectWithValidation from '@components/Form/SelectWithValidation';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import LimitlessFileInput from '@components/Limitless/LimitlessFileInputComponent.vue';

export default {
    name: 'NtapsFileBatchPrint',
    components: {
        LimitlessFileInput,
        LimitlessButton,
        SelectWithValidation,
    },
    data: () => ({
        set_as_defualt_printer: false,
        loading: false,
        sent_to_printer: false,
        response: null,
        errors: null,
        files: null,
        printer_tag: null,
    }),
    created() {
        const printerTag = Cookies.get('freightlabel_printer');
        if (printerTag) {
            this.printer_tag = printerTag;
        }
    },
    methods: {
        async printBatch() {
            if (this.files && this.printer_tag) {
                this.loading = true;
                if (this.set_as_defualt_printer) {
                    Cookies.set('freightlabel_printer', this.printer_tag, { expires: 365 });
                    this.set_as_defualt_printer = false;
                }

                const formData = new FormData();
                formData.append('file', this.files[0]);
                formData.append('printer_tag', this.printer_tag);
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
                await apiClient.post('/vue/batch/fileprint', formData, config)
                    .then((response) => {
                        this.sent_to_printer = true;
                        this.response = response.data;
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.errors = parsederror;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        inputFileChanged(files) {
            this.files = files;
        },
    },
};
</script>
